define(["require", "exports"], function (require, exports) {
    "use strict";
    exports.__esModule = true;
    function changeVal($input, factor) {
        var min = parseInt($input.attr('min'));
        var max = parseInt($input.attr('max'));
        var step = parseInt($input.attr('step'));
        var prev = parseInt($input.val());
        var cur = Math.max(min, Math.min(max, prev + factor * step));
        $input.val(cur);
        return $input.trigger('change');
    }
    function initialize($range, settings) {
        var $input = $range.find('.controls input[type="range"]');
        var $inc = $input.next('button');
        var $dec = $input.prev('button');
        $input.attr({
            min: settings.min,
            max: settings.max,
            step: settings.step
        })
            .val(settings.initVal);
        $range.find('label').html(settings.label + " (" + settings.min + settings.shortUnit + "-" + settings.max + settings.shortUnit + "): <span class=\"current\"></span>");
        $inc.off('click').on('click', function () { return changeVal($input, 1); });
        $dec.off('click').on('click', function () { return changeVal($input, -1); });
        $input.off('input').on('input', function () {
            var $cur = $range.find('label span.current');
            var val = $input.val();
            var valText = "" + val + settings.shortUnit;
            $cur.text(valText);
            settings.cur.text(valText);
        });
        $input.off('change').on('change', function () {
            var $cur = $range.find('label span.current');
            var val = $input.val();
            var valText = "" + val + settings.shortUnit;
            $cur.text(valText);
            $("#" + settings.id).val(val).data('decimal', val).trigger('change');
        });
        $input.trigger('change');
    }
    exports.initialize = initialize;
});



//////////////////
// WEBPACK FOOTER
// ./Scripts/built/numberRange.js
// module id = 80
// module chunks = 0